import { PlanType } from '../domain/subscription/SubscriptionDTO';

export const PLAN_TYPE = {
  MONKEY: `monkey` as PlanType,
  GORILLA: `gorilla` as PlanType,
  KONG: `kong` as PlanType,
} as { [key: string]: PlanType };

export const SMARTMONKEY_TO_ROUTAL_NAMES = {
  monkey: `Routal Light`,
  gorilla: `Routal Standard`,
  kong: `Routal North Star`,
  [`drivers:free`]: `Routal Drivers Free`,
  [`drivers:lite`]: `Routal Drivers Lite`,
};

export const SMARTMONKEY_TO_ROUTAL_SHORT_NAMES = {
  monkey: `Light`,
  gorilla: `Standard`,
  kong: `North Star`,
  [`drivers:free`]: `Drivers Free`,
  [`drivers:lite`]: `Drivers Lite`,
};
